import URLConfig from '@Config/urls/url.config';

export default function generateTransactionHistoryLink(id: string): string {
    return URLConfig.ADMIN.ARCHIVING.ARCHIVED_TABLES_MENU
    .VALID_TRANSACTION_INQUIRY_HISTORY + id + '/transaction';
}